import GenerateInvoiceModal from './GenerateInvoiceModal';
export default GenerateInvoiceModal;
